import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import useStyles from './ActionButtons.styles';

const ActionButtons = ({
  actionButtonText,
  handleClose,
  handleReset,
  isActionDisabled,
  resetButtonText,
  formLabelId,
}) => {
  const { classes } = useStyles();
  const handleButtonKeyDown = event => {
    const EVENT_TYPES = ['Escape', 'Esc'];
    if (EVENT_TYPES.includes(event.key)) {
      handleClose();
    }
  };
  return (
    <div className={classes.actionButtonSection}>
      <Button
        className={classes.button}
        data-testid="dropdownButtonReset"
        aria-describedby={formLabelId}
        disabled={isActionDisabled}
        disableRipple
        disableFocusRipple
        onClick={handleReset}
        size="large"
        variant="outlined"
        onTouchStart={event => {
          handleReset();
          event.preventDefault();
        }}
        onTouchEnd={event => {
          event.preventDefault();
        }}
        onKeyDown={event => {
          handleButtonKeyDown(event);
        }}
      >
        {resetButtonText}
      </Button>
      <Button
        className={classes.button}
        color="primary"
        data-testid="dropdownButtonAction"
        aria-describedby={formLabelId}
        disabled={isActionDisabled}
        disableRipple
        disableFocusRipple
        onClick={handleClose}
        size="large"
        variant="contained"
        onKeyDown={handleButtonKeyDown}
      >
        {actionButtonText}
      </Button>
    </div>
  );
};

ActionButtons.propTypes = {
  actionButtonText: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  isActionDisabled: PropTypes.bool.isRequired,
  handleReset: PropTypes.func.isRequired,
  resetButtonText: PropTypes.string.isRequired,
  formLabelId: PropTypes.string.isRequired,
};

export default ActionButtons;
